var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPickUpInBoutique = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5414"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f1f1f1",
  d: "M36 0A36 36 0 1 1 0 36 36 36 0 0 1 36 0",
  "data-name": "Path 5054"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4021"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4008"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4007"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4006"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M20.804 52.756h-4.859a.84.84 0 0 1-.841-.838V36.459a.841.841 0 1 1 1.682 0v14.615h4.018a.841.841 0 0 1 0 1.682",
  "data-name": "Path 4647"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4011"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4010"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4009"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M39.492 52.756H27.718a.841.841 0 0 1 0-1.682h10.933v-16.82H27.446a.841.841 0 1 1 0-1.682h12.046a.84.84 0 0 1 .841.841v18.5a.84.84 0 0 1-.841.843",
  "data-name": "Path 4648"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4014"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4013"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4012"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M51.266 52.756h-3.364a.841.841 0 1 1 0-1.682h2.523V45.22a5 5 0 0 0-5-5h-5.1v10.854h.841a.841.841 0 0 1 0 1.682h-1.674a.84.84 0 0 1-.841-.841V39.384a.84.84 0 0 1 .841-.841h5.937a6.686 6.686 0 0 1 6.677 6.677v6.694a.84.84 0 0 1-.84.842",
  "data-name": "Path 4649"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4017"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4016"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4015"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M24.35 56.12a4.2 4.2 0 1 1 4.2-4.2 4.21 4.21 0 0 1-4.2 4.2m0-6.728a2.523 2.523 0 1 0 2.528 2.518 2.526 2.526 0 0 0-2.528-2.518",
  "data-name": "Path 4650"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4020"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4019"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4018"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M44.533 56.12a4.2 4.2 0 1 1 4.2-4.2 4.21 4.21 0 0 1-4.2 4.2m0-6.728a2.523 2.523 0 1 0 2.528 2.518 2.526 2.526 0 0 0-2.528-2.518",
  "data-name": "Path 4651"
}))))), /*#__PURE__*/React.createElement("g", {
  fill: "#0e2240"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.207 28.895h-.1a3.4 3.4 0 0 1-1.672-.611l-.064-.064a.436.436 0 0 0-.547-.032l-.032.032a3.4 3.4 0 0 1-2.09.675 3.52 3.52 0 0 1-2.186-.739.29.29 0 0 0-.386 0 3.45 3.45 0 0 1-2.218.772 3.3 3.3 0 0 1-2.122-.707c-.032-.032-.064-.032-.1-.064a.3.3 0 0 0-.386 0 3.46 3.46 0 0 1-2.057.772.263.263 0 0 0-.257.289v5.979a.486.486 0 0 0 .45.482h7.458a.486.486 0 0 0 .45-.482v-4.245c.032-.129.1-.257.418-.257h3.568c.129.032.257.129.257.418v4.018c0 .45.321.514.418.514h1.125c.1 0 .418-.064.418-.514v-5.818c-.054-.322-.216-.386-.345-.418m-8.037 4.629v.129a.42.42 0 0 1-.482.418h-3.279c-.354 0-.45-.161-.482-.321v-2.444c0-.579.321-.611.45-.611h3.408c.129 0 .386.1.386.514Z",
  "data-name": "Path 164"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.851 27.283a2.39 2.39 0 0 0 3.022-1.961v-.064a5 5 0 0 0-.222-.542c-.964-1.736-1.9-3.472-2.829-5.208a.52.52 0 0 0-.482-.225H47.123s-.354 0-.482.225c-.964 1.736-1.9 3.5-2.829 5.208a1.4 1.4 0 0 0-.161.579v.064a2.26 2.26 0 0 0 .739 1.414 2.33 2.33 0 0 0 2.475.482 2.46 2.46 0 0 0 1.222-1c.032-.032.064-.1.129-.129a.434.434 0 0 1 .611.129 1.95 1.95 0 0 0 .611.643 2.36 2.36 0 0 0 2.25.354 2.2 2.2 0 0 0 1.222-1 .436.436 0 0 1 .739 0l.193.289a2.32 2.32 0 0 0 1.543.836 2.43 2.43 0 0 0 2.315-1.125.42.42 0 0 1 .707 0 2.16 2.16 0 0 0 1.318 1Z",
  "data-name": "Path 165"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M23.555 42.04a10.73 10.73 0 0 1 .744-8.752 10.605 10.605 0 0 1 12.019-5.195l-.55.992a.628.628 0 0 0 .677.92l5.683-1.173a.63.63 0 0 0 .421-.307.61.61 0 0 0 .043-.52l-1.905-5.321a.628.628 0 0 0-1.142-.093l-.642 1.157a13.584 13.584 0 0 0-17.724 5.723 13.73 13.73 0 0 0 1.073 14.921Zm-1.277-11.96a12.305 12.305 0 0 1 16.579-4.941.63.63 0 0 0 .85-.247l.264-.476 1.194 3.332-3.634.75.263-.475a.63.63 0 0 0-.245-.854 1 1 0 0 0-.098-.044A11.84 11.84 0 0 0 23.2 32.678a12 12 0 0 0-.973 9.391 12.5 12.5 0 0 1 .052-11.989Z",
  "data-name": "Path 4652"
}))));
export { SvgPickUpInBoutique as ReactComponent };
export default "/_next/static/images/pickUpInBoutique.svg";